import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function Payment({ userData, fetchUser, setShowSwitch }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [amount, setAmount] = useState(0)

  const isTurningOn = userData.turnoff_payment

  async function changeRole() {
    const data = {
      userId: id,
      status: isTurningOn ? false : true,
      amount: amount,
    }
    if (!isTurningOn && amount < 1) {
      notify('warn', 'Enter Amount')
      return
    }
    setCancelLoading(true)
    put(`user/payment-flag`, data)
      .then((result: any) => {
        if (result.status === 201) {
          notify('success', 'Customer Payment Status Updated')
          setShowSwitch(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className={`modal-icon ${isTurningOn ? 'icon-green' : 'icon-red'}`}>
            <Icon icon={isTurningOn ? 'mdi:toggle-switch' : 'mdi:toggle-switch-off'} />
          </div>
          <h2>
            Turn {isTurningOn ? 'On' : 'Off'} Payment
          </h2>
          <p>
            This user will {isTurningOn ? '' : 'not '}be required to pay during booking.
          </p>
        </div>

        <div className={`status-indicator ${isTurningOn ? 'status-off' : 'status-on'}`}>
          <div className='dot' />
          <p>
            Current status:{' '}
            <span>{userData.turnoff_payment ? 'Payment OFF' : 'Payment ON'}</span>
          </p>
        </div>

        {!isTurningOn && (
          <div className='form-group'>
            <label>Credit Limit (NGN)</label>
            <input
              type='number'
              min={1}
              placeholder='e.g. 50000'
              onChange={(e) => setAmount(parseFloat(e.target.value))}
            />
          </div>
        )}

        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={() => setShowSwitch(false)}>
              Cancel
            </button>
            <button
              className={isTurningOn ? 'btn-proceed' : 'btn-danger'}
              onClick={changeRole}
            >
              Confirm
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default Payment
